import React from "react";
import Grid from "@material-ui/core/Grid";
import ImgMediaCard from "components/Project/ImageCard";
import ProjectPagination from "./../../../General/ProjectPagination";
import { paginate } from "../../../../utils/paginate";
import { FaCheck } from "react-icons/fa";

class GiftGrid extends React.Component {
  state = {
    pageSize: 9,
    currentPage: 1,
  };

  giftSelectedHandler(value) {
    var elems = document.getElementsByClassName("prize-box");
    [].forEach.call(elems, function (el) {
      el.classList.remove("active");
    });
    document.getElementById("prize_" + value).classList.add("active");
    this.props.onClick(value);
  }

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  render() {
    let filtered = this.props.prizeData;

    const prizePaginated = paginate(
      filtered,
      this.state.currentPage,
      this.state.pageSize
    );
    return (
      <div style={{ flexGrow: 1 }}>
        <Grid
          container
          spacing={2}
          direction="row"
          justify="flex-start"
          alignItems="flex-start"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "20px",
          }}
        >
          {prizePaginated
            .sort((a, b) => (a.name > b.name ? 1 : -1))
            .map((elem) => {
              return (
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={4}
                  key={this.props.prizeData.indexOf(elem)}
                  className="prize-box"
                  id={"prize_" + elem.prize_id}
                >
                  <span className="check">
                    <FaCheck size={18} style={{ fill: "#ff431b" }} />
                  </span>
                  <ImgMediaCard
                    imageSrc={elem.prize_url}
                    imageId={elem.prize_id}
                    onClick={this.giftSelectedHandler.bind(this)}
                  />
                </Grid>
              );
            })}
        </Grid>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "30px",
          }}
        >
          <ProjectPagination
            itemsCount={this.props.prizeData.length}
            pageSize={this.state.pageSize}
            onPageChange={this.handlePageChange}
            currentPage={this.state.currentPage}
          />
        </div>
      </div>
    );
  }
}

export default GiftGrid;
